import {DynamicInstanceRestService} from './restServices';
import storageService from '../storageService';

var service = {};

service.createDynamicFormInstance = async (formInstanceObj, token) => {
  try {
    const newFormInstanceObj = {
      ...formInstanceObj,
      token: token ? token : storageService.getItem('token'),
    };
    const response = await DynamicInstanceRestService.save(
      {
        endpoint: '',
      },
      newFormInstanceObj,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// service.getDynamicFormInstance = async (
//   dynamicFormInstanceId,
//   mentorUserId,
//   token,
// ) => {
//   const _token = token ? token : storageService.getItem('token');
//   const response = await DynamicInstanceRestService.get(
//     {
//       endpointParam: mentorUserId,
//       endpointParam2: `${dynamicFormInstanceId}/?token=${_token}`,
//     },
//     null,
//   );
//   return response.data;
// };
service.getDynamicFormInstances = async ({
  fromDate,
  toDate,
  pageNumber,
  pageSize,
  mentorIds,
  token,
}) => {
  try {
    const _token = token ? token : storageService.getItem('token');
    const requestObj = {
      endpointParam: 'mentorIds',
      fromDate,
      toDate,
      pageNumber,
      pageSize,
      mentorIds,
      token: _token,
    };
    const response = await DynamicInstanceRestService.get(
      requestObj,
      requestObj,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
service.deleteDynamicFormInstance = async (dynamicFormInstanceId) => {
  const _token = storageService.getItem('token');
  const response = await DynamicInstanceRestService.delete(
    {},
    {
      dynamicFormInstanceIds: [dynamicFormInstanceId],
      token: _token,
    },
  );
  return response.data;
};

const dynamicInstanceService = {...service};
export default dynamicInstanceService;
